import $ from 'jquery';
import _ from 'underscore';
import Numeral from 'numeral';
import Cache from 'root/cache';
import Constants from 'root/constants';
import UI from 'root/ui';
import Svg_Icon from 'root/module/svg_icon';
import View from 'view/base';

export default View.extend({
    className: 'account-upgrade-plan-select',

    billing_interval: Constants.ANNUALLY,
    plan_type: Constants.PLAN_2025_BUSINESS,

    is_upgrade: false,

    events: {
        'click .billing-cycle-selection > span' : 'selectBillingCycle',
        'click .feature-compare'                : 'compreFeatures',
        'click .plan-continue'                  : 'continue',
        'click .lets-talk'                      : 'letsTalk'
    },

    dom_handlers: {
        selectBillingCycle: function(e) {
            if ($(e.currentTarget).hasClass('active')) {
                return;
            }

            if (this.billing_interval === Constants.MONTHLY) {
                this.billing_interval = Constants.ANNUALLY;

                this.$el.find('.billing-cycle-selection > span:first').removeClass('active');
                this.$el.find('.billing-cycle-selection > span:last').addClass('active');
            } else {
                this.billing_interval = Constants.MONTHLY;

                this.$el.find('.billing-cycle-selection > span:first').addClass('active');
                this.$el.find('.billing-cycle-selection > span:last').removeClass('active');
            }

            this.updatePrice();
        },

        compreFeatures: function(e) {
            this.$el.find('.feature-compare + div').toggle();
            this.$el.find('.feature-all').toggle();
        },

        letsTalk: function(e) {
            e.preventDefault();
            UI.openLiveChat();
        },

        continue: function(e) {
            var plan_type      = parseInt($(e.currentTarget).parents('.account-plan').data('type'), 10);
            var session_limit  = this.is_upgrade ? 0 : Cache.account.get('session_limit');
            var extra_user     = this.is_upgrade ? Cache.workspace_member.where({is_disabled: false}).length + Cache.user_invitation.length : Cache.account.get('extra_user');

            extra_user = Math.min(extra_user, Cache.account.getUserMax(plan_type));

            if (plan_type === Constants.PLAN_2025_CUSTOM && !this.hasCustom()) {
                return;
            }

            if (this.plan_type === Constants.PLAN_2025_CUSTOM) {
                if (Cache.account.get('premium_monthly_price') && Cache.account.get('premium_annual_price')) {

                } else if (Cache.account.get('premium_monthly_price')) {
                    this.billing_interval = Constants.MONTHLY;
                } else if (Cache.account.get('premium_annual_price')) {
                    this.billing_interval = Constants.ANNUALLY;
                }
            }

            this.trigger('continue', {
                billing_interval : this.billing_interval,
                plan_type        : plan_type,
                extra_user       : extra_user,
                session_limit    : session_limit
            });
        }
    },

    updatePrice: function() {
        var plan_container_team          = this.$el.find('.account-plan[data-type="' + Constants.PLAN_2025_TEAM + '"]');
        var plan_container_business      = this.$el.find('.account-plan[data-type="' + Constants.PLAN_2025_BUSINESS + '"]');
        var plan_container_business_plus = this.$el.find('.account-plan[data-type="' + Constants.PLAN_2025_BUSINESS_PLUS + '"]');

        plan_container_team.find('.price .number').text(Numeral(Cache.account.getPrice(Constants.PLAN_2025_TEAM, this.billing_interval, 0, 1)).format(','));
        plan_container_business.find('.price .number').text(Numeral(Cache.account.getPrice(Constants.PLAN_2025_BUSINESS, this.billing_interval, 0, 1)).format(','));
        plan_container_business_plus.find('.price .number').text(Numeral(Cache.account.getPrice(Constants.PLAN_2025_BUSINESS_PLUS, this.billing_interval, 0, 1)).format(','));

        if (this.hasCustom()) {
            if ((Cache.account.get('premium_monthly_price') && this.billing_interval === Constants.MONTHLY) ||
                (Cache.account.get('premium_monthly_price') && !Cache.account.get('premium_annual_price'))) {
                this.$el.find('.account-plan[data-type="' + Constants.PLAN_2025_CUSTOM + '"]').find('.price .number').text(Cache.account.getPrice(Constants.PLAN_2025_CUSTOM, this.billing_interval));
                this.$el.find('.account-plan[data-type="' + Constants.PLAN_2025_CUSTOM + '"]').find('.price .unit').text('/ month');
            } else {
                this.$el.find('.account-plan[data-type="' + Constants.PLAN_2025_CUSTOM + '"]').find('.price .number').text(Cache.account.getPrice(Constants.PLAN_2025_CUSTOM, this.billing_interval) * 12);
                this.$el.find('.account-plan[data-type="' + Constants.PLAN_2025_CUSTOM + '"]').find('.price .unit').text('/ year');
            }
        }
    },

    setBillingCycle: function(billing_interval) {
        this.billing_interval = parseInt(billing_interval, 10);
    },

    hasCustom: function() {
        return Cache.account.get('premium_monthly_price') || Cache.account.get('premium_annual_price') ? true : false;
    },

    initialize: function(options) {
        this.is_upgrade = Cache.account.get('is_trial') || Cache.account.get('is_expired') || Cache.account.isFreePlan() || (Cache.account.get('appsumo') && !Cache.account.get('credit_card_digit'));

        if (this.is_upgrade) {
            if (Cache.account.get('discount_plan_type')) {
                // default to the discounted billing interval
                this.billing_interval = Cache.account.get('discount_plan_type');
            }

            if (Cache.account.get('appsumo')) {
                this.plan_type = Cache.account.get('plan');
            }
        } else {
            // change plan
            this.billing_interval = Cache.account.get('billing_interval');
            this.plan_type        = Cache.account.get('plan');
        }
    },

    setOptions: function(options) {
        this.billing_interval = options.billing_interval;
        this.plan_type        = options.plan_type;
    },

    choosePlan: function(plan_type) {
        this.$el.find('.account-plan[data-type="' + plan_type + '"]').click();
    },

    continue: function(plan) {
        var selected_plan = plan || this.plan_type;
        this.$el.find('.account-plan[data-type="' + selected_plan + '"]').find('.plan-continue').click();
    },

    render: function() {
        var content = '';

        content += '<div class="account-plan-main">';

        content += '<div class="account-plan-container">' +
                        '<div class="account-plan-billing-cycle-selection">' +
                            '<div class="billing-cycle-selection badge-group-tertiary">' +
                                '<span' + ((this.billing_interval === Constants.MONTHLY  ? ' class="active"' : '')) + '>Monthly</span>' +
                                '<span' + ((this.billing_interval === Constants.ANNUALLY ? ' class="active"' : '')) + '>Yearly<span class="yearly-discount">Save 20%</span></span>' +
                            '</div>' +
                        '</div>' +

                        '<div class="account-plan-grid-container">' +
                            // Free
                            (this.hasCustom() ? '' :
                            '<div>' +
                                '<div class="account-plan account-plan-2025" data-type="' + Constants.PLAN_2025_FREE + '">' +
                                    '<div class="checkmark">' + Svg_Icon.tick + '</div>' +
                                    '<div class="title text-info">' + Cache.account.getPlanName(Constants.PLAN_2025_FREE) + '</div>' +
                                    '<div class="price">' +
                                        '<span class="dollar">$</span>' +
                                        '<span class="number">0</span>' +
                                        '<span class="unit">/ month</span>' +
                                    '</div>' +
                                    '<div><i class="fa-solid fa-asterisk fa-2xs"></i> Unlimited seats</div>' +
                                    '<div class="feature-list">' +
                                        '<div class="feature-select">' +
                                            '<button type="button" class="plan-continue primary small-medium full"' + (Cache.account.get('plan') === Constants.PLAN_2025_FREE ? ' disabled' : '') + '>Continue</button>' +
                                        '</div>' +
                                        '<div class="feature-key">' +
                                            '<div>' +
                                                '<b>Free Includes:</b>' +
                                                '<ul>' +
                                                    '<li>Collect unlimited feedback</li>' +
                                                    '<li>2 projects</li>' +
                                                    '<li>7-day feedback availibility</li>' +
                                                    '<li>All core features</li>' +
                                                '</ul>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="feature-all"><a href="https://userback.io/pricing#features" class="primary" target="help" rel="noopener">See all the features <i class="fa-solid fa-square-arrow-up-right"></i></a></div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>') +

                            // Team
                            '<div>' +
                                '<div class="account-plan account-plan-2025" data-type="' + Constants.PLAN_2025_TEAM + '">' +
                                    '<div class="checkmark">' + Svg_Icon.tick + '</div>' +
                                    '<div class="title text-success">' + Cache.account.getPlanName(Constants.PLAN_2025_TEAM) + '</div>' +
                                    '<div class="price">' +
                                        '<span class="dollar">$</span>' +
                                        '<span class="number"></span>' +
                                        '<span class="unit">per seat / month</span>' +
                                    '</div>' +
                                    '<div><i class="fa-solid fa-asterisk fa-2xs"></i> Max 5 seats</div>' +
                                    '<div class="feature-list">' +
                                        '<div class="feature-select">' +
                                            '<button type="button" class="plan-continue primary small-medium full">Continue</button>' +
                                        '</div>' +
                                        '<div class="feature-key">' +
                                            '<div>' +
                                                '<b>Everything in ' + Cache.account.getPlanName(Constants.PLAN_2025_FREE) + ', plus:</b>' +
                                                '<ul>' +
                                                    '<li>Collect unlimited feedback</li>' +
                                                    '<li>' + Cache.account.getProjectLimit(Constants.PLAN_2025_TEAM) + ' projects</li>' +
                                                    '<li>Customizable feedback widgets</li>' +
                                                    '<li>Feedback management tools</li>' +
                                                    '<li>User identification</li>' +
                                                    '<li>Project management integrations</li>' +
                                                '</ul>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="feature-all"><a href="https://userback.io/pricing#features" class="primary" target="help" rel="noopener">See all the features <i class="fa-solid fa-square-arrow-up-right"></i></a></div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +

                            // Business
                            '<div>' +
                                '<div class="account-plan account-plan-2025" data-type="' + Constants.PLAN_2025_BUSINESS + '">' +
                                    '<div class="checkmark">' + Svg_Icon.tick + '</div>' +
                                    '<div class="title text-dolphin">' + Cache.account.getPlanName(Constants.PLAN_2025_BUSINESS) + '</div>' +
                                    '<div class="price">' +
                                        '<span class="dollar">$</span>' +
                                        '<span class="number"></span>' +
                                        '<span class="unit">per seat / month</span>' +
                                    '</div>' +
                                    '<div>&nbsp;</div>' +
                                    '<div class="feature-list">' +
                                        '<div class="feature-select">' +
                                            '<button type="button" class="plan-continue primary small-medium full">Continue</button>' +
                                        '</div>' +
                                        '<div class="feature-key">' +
                                            '<div>' +
                                                '<b>Everything in ' + Cache.account.getPlanName(Constants.PLAN_2025_TEAM) + ', plus:</b>' +
                                                '<ul>' +
                                                    '<li>Collect unlimited feedback</li>' +
                                                    '<li>' + Cache.account.getProjectLimit(Constants.PLAN_2025_BUSINESS) + ' projects</li>' +
                                                    '<li>User surveys</li>' +
                                                    '<li>AI Assist</li>' +
                                                    '<li>Feedback automation tools</li>' +
                                                    '<li>Developer tools</li>' +
                                                    '<li>Reply templates</li>' +
                                                    '<li>Capture session replays</li>' +
                                                    '<li>User Segments</li>' +
                                                    '<li>JavaScript SDK</li>' +
                                                '</ul>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="feature-all"><a href="https://userback.io/pricing#features" class="primary" target="help" rel="noopener">See all the features <i class="fa-solid fa-square-arrow-up-right"></i></a></div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +

                            // Business Plus
                            '<div>' +
                                '<div class="account-plan account-plan-2025" data-type="' + Constants.PLAN_2025_BUSINESS_PLUS + '">' +
                                    '<div class="checkmark">' + Svg_Icon.tick + '</div>' +
                                    '<div class="title text-survey">' + Cache.account.getPlanName(Constants.PLAN_2025_BUSINESS_PLUS) + '</div>' +
                                    '<div class="price">' +
                                        '<span class="dollar">$</span>' +
                                        '<span class="number"></span>' +
                                        '<span class="unit">per seat / month</span>' +
                                    '</div>' +
                                    '<div>&nbsp;</div>' +
                                    '<div class="feature-list">' +
                                        '<div class="feature-select">' +
                                            '<button type="button" class="plan-continue primary small-medium full">Continue</button>' +
                                        '</div>' +
                                        '<div class="feature-key">' +
                                            '<div>' +
                                                '<b>Everything in ' + Cache.account.getPlanName(Constants.PLAN_2025_BUSINESS) + ', plus:</b>' +
                                                '<ul>' +
                                                    '<li>Collect unlimited feedback</li>' +
                                                    '<li>Unlimited projects</li>' +
                                                    '<li>Account branding</li>' +
                                                    '<li>Remove Userback logo</li>' +
                                                    '<li>SSO (min: 25 seats)</li>' +
                                                    '<li>Record all user sessions</li>' +
                                                    '<li>Sensitive data masking</li>' +
                                                    '<li>Email Forwarding <span class="badge-primary-invert badge-small badge-round font-weight-medium">New</span></li>' +
                                                    '<li>Rest API access </li>' +
                                                    '<li>Webhooks</li>' +
                                                '</ul>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="feature-all"><a href="https://www.userback.io/pricing#features" class="primary" target="help" rel="noopener">See all the features <i class="fa-solid fa-square-arrow-up-right"></i></a></div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' +

                            // Custom
                            (this.hasCustom() ?
                            '<div>' +
                                '<div class="account-plan account-plan-2025" data-type="' + Constants.PLAN_2025_CUSTOM + '">' +
                                    '<div class="checkmark">' + Svg_Icon.tick + '</div>' +
                                    '<div class="title text-feedback">' + Cache.account.getPlanName(Constants.PLAN_2025_CUSTOM) + '</div>' +
                                    '<div class="price">' +
                                        '<span class="dollar">$</span>' +
                                        '<span class="number">100</span>' +
                                        '<span class="unit">/ month</span>' +
                                    '</div>' +
                                    '<div>' + Numeral(Cache.account.get('premium_user_limit')).format(',') + ' seats' + (Cache.account.get('premium_session_limit') ? ' & ' + Numeral(Cache.account.get('premium_session_limit')).format(',') + ' sessions': '') + '</div>' +
                                    '<div class="feature-list">' +
                                        '<div class="feature-select">' +
                                            '<button type="button" class="plan-continue primary small-medium full">Continue</button>' +
                                        '</div>' +
                                        '<div class="feature-key">' +
                                            '<div>' +
                                                '<b>Everything in ' + Cache.account.getPlanName(Constants.PLAN_2025_BUSINESS_PLUS) + ', plus:</b>' +
                                                '<ul>' +
                                                    '<li>Implementation Support</li>' +
                                                    '<li>Premium Support</li>' +
                                                    '<li>Invoice Payment</li>' +
                                                    '<li>SOC2 Type 2 Report</li>' +
                                                '</ul>' +
                                            '</div>' +
                                        '</div>' +
                                        '<div class="feature-all"><a href="https://userback.io/pricing#features" class="primary" target="help" rel="noopener">See all the features <i class="fa-solid fa-square-arrow-up-right"></i></a></div>' +
                                    '</div>' +
                                '</div>' +
                            '</div>' : '') +
                        '</div>' +

                        '<div class="text-align-center text-info margin-top-32">All currency is in USD. </div>' +

                        (this.hasCustom() ? '' :
                        '<div class="text-align-center text-info margin-top-16">Tailor a custom plan to suit your needs. <a href="#" class="primary font-weight-medium lets-talk">Let\'s talk</a>.</div>') +
                    '</div>';

        content += '</div>';

        this.$el.html(content);

        // included limits
        this.$el.find('.account-plan').each(function() {
            $(this).find('.dropdown-response-limit li:first').click();
            $(this).find('.dropdown-session-limit li:first').click();
        });

        if (!this.is_upgrade) {
            var plan_container = this.$el.find('.account-plan[data-type="' + Cache.account.get('plan') + '"]');

            plan_container.addClass('account-plan-myplan');

            // select response limit
            plan_container.find('.dropdown-response-limit li[data-val="' + Cache.account.get('response_limit') + '"]').click();

            // select session limit
            plan_container.find('.dropdown-session-limit li[data-val="' + Cache.account.get('session_limit') + '"]').click();
        }

        if (Cache.account.get('appsumo')) {
            this.$el.find('.account-plan').addClass('account-plan-disabled');
            this.$el.find('.account-plan[data-type="' + this.plan_type + '"]').removeClass('account-plan-disabled');
        }

        this.updatePrice();

        return this;
    }
});
